import { useCallback, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
// Components
import BannerOne from "../../../components/BannerOne";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";

// Constants
import { TITLE, SUB_TITLE } from "./EnablementConstants";
import {
  SALES_LINK,
  SALES_TEXT,
  SALES_SPECIALIST_TEXT,
  SALES_SPECIALIST_LINK,
  SALES_ENGINEER_TEXT,
  SALES_ENGINNER_LINK,
  DELIVERY_CONSULTANT_TEXT,
  DELIVERY_CONSULTANT_LINK,
} from "./EnablementConstants";
import {
  TITLE_ONE,
  TITLE_TWO,
  TITLE_THREE,
  TITLE_FOUR,
  SUB_TITLE_ONE,
  SUB_TITLE_TWO,
  SUB_TITLE_THREE,
  SUB_TITLE_FOUR,
} from "./EnablementConstants";

// actions
import * as enablementAction from "../../../actions/partnerPortal/enablement/EnablementAction";

// Images
import whatsNew from "../../../assets/img/partnerPortal/EnablementSales/whatsNew.png";
import demoEnv from "../../../assets/img/partnerPortal/EnablementSales/demoEnv.png";
import banner from "../../../assets/img/partnerPortal/homepage.png";
import salesIcon from "../../../assets/img/partnerPortal/EnablementSales/sales_icon.svg";
import salesSpecialistIcon from "../../../assets/img/partnerPortal/EnablementSales/sales_specialist_icon.svg";
import salesEngineerIcon from "../../../assets/img/partnerPortal/EnablementSales/sales_engineer_icon.svg";
import deliveryConsultantIcon from "../../../assets/img/partnerPortal/EnablementSales/delivery_consultant_icon.svg";
import checkmark from "../../../assets/img/partnerPortal/welcomeAccenture/checkmark-small.svg";

// Scss
import "../../../assets/css/partnerPortal/appDeveloper.scss";
import "../../../assets/css/partnerPortal/salesEnablement.scss";
import "../../../assets/css/partnerPortal/sales.scss";
import "../../../assets/css/partnerPortal/welcome.scss";
import "../../../assets/css/partnerPortal/calendar.scss";

import NewsSectionTwo from "../../../components/NewsSectionTwo";
import ButtonArrow from "../../../components/ButtonArrow";
import CardRole from "../../../components/CardRole";
import SubscriptionRequestDTO from "../../../models/SubscriptionRequestDTO";
import UnsubscriptionRequestDTO from "../../../models/UnsubscriptionRequestDTO";
import ButtonOne from "../../../components/ButtonOne";
import EventCLusterDTO from "../../../models/EventClusterDTO";
import { ButtonGroup, ToggleButton } from "react-bootstrap";
import arrowWhite from "../../../assets/img/partnerPortal/homepage/arrowWhite.png";

moment.locale("en-GB");
const localizer = momentLocalizer(moment);

function Enablement() {
  let history = useHistory();

  const [show, setShow] = useState(false);
  const [showUns, setShowUns] = useState(false);
  const handleClose = () => closeForm();
  const handleShow = () => setShow(true);
  const handleShowUns = () => setShowUns(true);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [apiResponse, setApiResponse] = useState(<span></span>);
  //   const [events, setEvents] = useState(Array<EventDTO>());
  let [eventsData, setEventsData] = useState(
    Array<{ title; start; end; link; region; type }>()
  );
  const [eventsDataAll, setEventsDataAll] = useState(
    Array<{ title; start; end; link; region; type }>()
  );
  const [buttonChecked, setButtonChecked] = useState("all");

  const [form, setForm] = useState({
    email: "",
    name: "",
    REGIONS: [],
    TRAINING: [],
  });

  const onNavigate = useCallback(
    (event) => ({
      ...(event.region === "EMEA" && {
        className: "emea-color",
      }),
      ...(event.region === "NORAM" && {
        className: "noram-color",
      }),
      ...(event.region === "LATAM" && {
        className: "latam-color",
      }),
      ...(event.region === "APAC" && {
        className: "apac-color",
      }),
      ...(event.type === "WEBINAR" && {
        className: "live-webinar-color",
      }),
    }),
    []
  );

  useEffect(() => {
    canYouHaveAccess();
    getAllEvents();
  }, []);

  function filterCalendarByType(type: string) {
    setButtonChecked(type);
    if (type === "all") setEventsData(eventsDataAll);
    else {
      const eventsFiltered = eventsDataAll.filter((e) => e.type === type);
      setEventsData(eventsFiltered);
    }
    // setEventsData
  }

  // localStorage from zinfi to input field
  window.addEventListener(
    "message",
    function (event) {
      var origin = event.origin; // For Chrome, the origin property is in the event.originalEvent object.
      if (origin !== "https://partners.dynatrace.com") {
        return;
      }

      if (typeof event.data == "object" && event.data.call == "sendValue") {
        // Do something with event.data.value;
        var userInfo = event.data.value;
        if (origin == "https://partners.dynatrace.com") {
          console.log(userInfo);
          setForm({
            ...form,
            ["email"]: userInfo.email,
            ["name"]: userInfo.first_name + " " + userInfo.last_name,
          });
        }
      }
    },
    false
  );

  function openCalendarDay(e) {
    window.open(e.link, "_blank");
  }

  return (
    <>
      <div className="mb-3">
        {/* <BannerOne bannerImage={banner} title={TITLE} hasNoButton={true} /> */}
        <div className={"row d-flex "}>
          <img src={banner} className=" shadow-4 imageBanner " alt="..." />
          <div className="boxBanner addMarginTop8">
            <div className="boxHeaderText">{TITLE}</div>
            <div className="boxHeaderSubText">
              {
                "Subscribe to our training events calendar to get the latest on bootcamps and webinars"
              }
            </div>
            <div className="d-flex flex-column align-items-center width67">
              <div className="d-flex align-items-center justify-content-center align-self-stretch ">
                <div
                  role="button"
                  onClick={handleShow}
                  className="w-100 d-flex justify-content-end mr-2"
                >
                  <div className="d-flex align-items-center justify-content-center width39 increaseWidth100 buttonBackground paddingButtonSubs">
                    <div className="buttonLettersStyle buttonBlack">
                      Subscribe
                    </div>
                  </div>
                </div>
                <div
                  role="button"
                  onClick={handleShowUns}
                  className="w-100 d-flex justify-content-start ml-2"
                >
                  <div className="d-flex align-items-center justify-content-center width39 increaseWidth100 secondaryButtonUnsub paddingButtonSubs buttonWhite">
                    <div className="buttonLettersStyle">Unsubscribe</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <BannerOne bannerImage={banner} title={TITLE} subTitle={SUB_TITLE} buttonName={BUTTON_NAME} buttonLink={BUTTON_LINK} secondButtonName={SECOND_BUTTON_NAME} secondButtonLink={SECOND_BUTTON_LINK} isArrowDown={true} /> */}
        <div className="containerAll">
          {/* <div id="subscription" className="d-flex flex-column align-items-start margin96Botton w-100 margin96Top ">
                    <div className="d-flex flex-column align-items-center justify-content-center bannerSubscribe  w-100">
                        <div className="d-flex flex-column align-items-center width67">
                            <div className="d-flex align-items-stretch align-items-start mb-4">
                                <div className="subscriptionText">Subscribe to our training events calendar to get the latest on bootcamps and webinars</div>
                            </div>

                            <div className="d-flex align-items-center justify-content-center align-self-stretch ">
                                <div role="button" onClick={handleShow} className="w-100 d-flex justify-content-end mr-2"  >
                                    <div className="d-flex align-items-center justify-content-center width39 increaseWidth100 buttonBackground paddingButtonSubs">
                                        <div className="buttonLettersStyle buttonBlack">Subscribe</div>
                                    </div>
                                </div>
                                <div role="button" onClick={handleShowUns} className="w-100 d-flex justify-content-start ml-2"  >
                                    <div className="d-flex align-items-center justify-content-center width39 increaseWidth100 secondaryButtonUnsub paddingButtonSubs buttonWhite">
                                        <div className="buttonLettersStyle">Unsubcribe</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}

          <div className="width66 mb-4">
            <div className="introframeHeader">Role-based training</div>
            <div className="introframeSubText justify-content-center">
              Jump into your enablement journey with learning paths tailored to
              your role.
            </div>
          </div>

          <div className="flexToBlockCard align-items-center w-100 margin96Botton">
            <CardRole
              icon={salesIcon}
              title="Sales"
              subTitle={SALES_TEXT}
              buttonLink={SALES_LINK}
              addMargin={"margin32"}
            />
            <CardRole
              icon={salesSpecialistIcon}
              title="Sales specialist"
              subTitle={SALES_SPECIALIST_TEXT}
              buttonLink={SALES_SPECIALIST_LINK}
              addMargin={"margin32"}
            />
            <CardRole
              icon={salesEngineerIcon}
              title="Sales engineer"
              subTitle={SALES_ENGINEER_TEXT}
              buttonLink={SALES_ENGINNER_LINK}
              addMargin={"margin32"}
            />
            <CardRole
              icon={deliveryConsultantIcon}
              title="Delivery consultant"
              subTitle={DELIVERY_CONSULTANT_TEXT}
              buttonLink={DELIVERY_CONSULTANT_LINK}
              addMargin={"margin32 noMargin"}
            />
          </div>

          <div
            id="calendar"
            className="d-flex flex-column margin96Botton w-100 "
          >
            <div className="d-flex flex-column align-items-center mb-5  ">
              <div className="d-flex align-items-center align-self-stretch textStyle colorBlack m-auto">
                Live training calendar
              </div>
            </div>
            <div className="marginButtonNegative">
              <div className="introframeSubText justify-content-center">
                Register for an upcoming enablement event by clicking on the
                relevant calendar item.
                <br />
                Find enablement events in your preferred time zone by using the
                color codes below.
              </div>
              <div className="flexToBlockCard align-items-center w-100 mb-5">
                <div className="d-flex align-items-center flex-column width25 grow100">
                  <div className="d-flex flex-column align-items-center align-self-stretch justify-content-between m-2">
                    <div className="d-flex align-items-start align-self-stretch justify-content-center calendarSubtitles noram-color p-2">
                      Americas (English)
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center flex-column width25 grow100">
                  <div className="d-flex flex-column align-items-center align-self-stretch justify-content-between m-2">
                    <div className="d-flex align-items-start align-self-stretch justify-content-center calendarSubtitles latam-color p-2">
                      Americas (Spanish)
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center flex-column width25 grow100">
                  <div className="d-flex flex-column align-items-center align-self-stretch justify-content-between m-2">
                    <div className="d-flex align-items-start align-self-stretch justify-content-center calendarSubtitles emea-color p-2">
                      Europe | Middle East | Africa
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center flex-column width25 grow100">
                  <div className="d-flex flex-column align-items-center align-self-stretch justify-content-between m-2">
                    <div className="d-flex align-items-start align-self-stretch justify-content-center calendarSubtitles apac-color p-2">
                      Asia | Australasia
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="introframeSubText justify-content-center">
                            <b>Filters</b>
                        </div> */}
              <div className="d-flex align-items-center w-100 margin96Botton justify-content-end">
                <ButtonGroup toggle className="mb-2">
                  <ToggleButton
                    key="1"
                    id="toggle-check"
                    value={"Show all"}
                    type="radio"
                    name="Show all"
                    variant="outline-dark"
                    checked={buttonChecked === "all"}
                    onChange={() => filterCalendarByType("all")}
                  >
                    Show all
                  </ToggleButton>
                  <ToggleButton
                    key="1"
                    id="toggle-check"
                    value={"ASSOCIATE"}
                    type="radio"
                    name="ASSOCIATE"
                    variant="outline-dark"
                    checked={buttonChecked === "ASSOCIATE"}
                    onChange={() => filterCalendarByType("ASSOCIATE")}
                  >
                    Associate Certification Bootcamp
                  </ToggleButton>
                  <ToggleButton
                    key="1"
                    id="toggle-check"
                    value={"PROFESSIONAL"}
                    type="radio"
                    name="PROFESSIONAL"
                    variant="outline-dark"
                    checked={buttonChecked === "PROFESSIONAL"}
                    onChange={() => filterCalendarByType("PROFESSIONAL")}
                  >
                    Professional Certification Bootcamp
                  </ToggleButton>
                  <ToggleButton
                    key="1"
                    id="toggle-check"
                    value={"TECHNICAL_SALES"}
                    type="radio"
                    name="ASSOCIATE"
                    variant="outline-dark"
                    checked={buttonChecked === "TECHNICAL_SALES"}
                    onChange={() => filterCalendarByType("TECHNICAL_SALES")}
                  >
                    Technical Sales
                  </ToggleButton>
                  <ToggleButton
                    key="1"
                    id="toggle-check"
                    value={"WEBINAR"}
                    type="radio"
                    name="WEBINAR"
                    variant="outline-dark"
                    checked={buttonChecked === "WEBINAR"}
                    onChange={() => filterCalendarByType("WEBINAR")}
                  >
                    Live Webinars
                  </ToggleButton>
                  <ToggleButton
                    key="1"
                    id="toggle-check"
                    value={"HOT"}
                    type="radio"
                    name="HOT"
                    variant="outline-dark"
                    checked={buttonChecked === "HOT"}
                    onChange={() => filterCalendarByType("HOT")}
                  >
                    HOT
                  </ToggleButton>
                </ButtonGroup>
              </div>
            </div>
            <Calendar
              views={["month"]}
              selectable
              localizer={localizer}
              defaultDate={new Date()}
              defaultView="month"
              events={eventsData}
              style={{ height: "100vh" }}
              onSelectEvent={openCalendarDay}
              eventPropGetter={onNavigate}
            />
          </div>

          {/* <div className="d-flex flex-column align-items-start margin96Botton">
                    <div className="d-flex pb-0 align-items-start">
                        <div className="d-flex flex-column align-items-start mr-4">
                            <div className="d-flex align-items-start pb-0 align-self-stretch">
                                <div className="titleCert">Certification exam<br></br> Second chance</div>
                            </div>
                            <div className="d-flex align-items-start pb-0 align-self-stretch mt-4">
                                <div className="subTitleCert">If you tried the Associate exam and barely missed, here’s your second chance. Reach out if:</div>
                            </div>
                        </div>
                        <div className="d-flex flex-column align-items-start">
                            <div className="productItem mb-3">
                                <img src={checkmark} />
                                <div className="contactGeneral fontWeight800 fontSize18">
                                    You belong to a Company that has a valid Partner agreement with Dynatrace
                                </div>
                            </div>
                            <div className="productItem mb-3">
                                <img src={checkmark} />
                                <div className="contactGeneral fontWeight800 fontSize18">
                                    You have not reached the 80% pass rate, but your result was 74% or higher
                                </div>
                            </div>
                            <div className="productItem mb-3">
                                <img src={checkmark} />
                                <div className="contactGeneral fontWeight800 fontSize18">
                                    You have paid for the exam or have participated in the Associate Certification Bootcamp
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex flex-column align-items-start secondChanceBanner">
                        <div className="d-flex flex-column align-items-center align-self-stretch">
                            <div className="flexToBlockCard align-items-center align-self-stretch m-4">
                                <div className="titleCert lineHeight28 fontSize18 width84 mr-4">
                                    Please contact the Partner Program Manager in your region. They will work with you to increase your skills, 
                                    and then offer a voucher for your second try-out
                                </div>
                                <div className="d-flex align-items-start width14">
                                    <ButtonOne text={"Contact us"} link={"mailto:partneroperations@dynatrace.com"} withoutIcon={true} classNameOfA={"w-100"} className={"pb-2 pt-2"}/>
                                   
                                </div>
                            </div>
                        </div>
                    </div>

                </div> */}

          <div className="d-flex flex-column align-items-center mx-auto ">
            <div className="d-flex flex-column align-items-center width63 mb-5  ">
              <div className="d-flex align-items-center align-self-stretch textStyle colorBlack m-auto">
                Resources
              </div>
            </div>
            <div className="align-items-start displayFlex justify-content-center">
              <div className="d-flex flex-column align-items-center cardBackground width31 mr-4 ml-3">
                <img src={whatsNew} width={"100%"} />
                <div className="d-flex flex-column align-items-start align-self-stretch w-100 cardPadding">
                  <div className="d-flex flex-column align-items-center align-self-stretch mb-4">
                    <div className="d-flex align-items-start align-self-stretch cardTitleApp mb-2">
                      What's New in Dynatrace
                    </div>
                    <div className="d-flex align-items-start align-self-stretch justify-content-center cardSubTitleApp mb-2">
                      Dynatrace is continuously innovating and pushing out
                      product updates bi-weekly. To learn Whats New in
                      Dynatrace, we provide monthly videos where our product
                      specialists walk you through the latest release notes,
                      documentation, community updates, and top blog posts so
                      that you're always up-to-date.
                    </div>
                  </div>
                  <ButtonArrow
                    link={
                      "https://www.youtube.com/playlist?list=PLqt2rd0eew1b2ITdLoq2awjxGCQ4QBmXM"
                    }
                    buttonName={"watch the videos"}
                    width="15%"
                  />
                </div>
              </div>
              <div className="d-flex flex-column align-items-center cardBackground width31 mr-4 ">
                <img src={demoEnv} width={"100%"} />
                <div className="d-flex flex-column align-items-start align-self-stretch w-100 cardPadding">
                  <div className="d-flex flex-column align-items-center align-self-stretch mb-4">
                    <div className="d-flex align-items-start align-self-stretch cardTitleApp mb-2">
                      Access the Demo environment
                    </div>
                    <div className="d-flex align-items-start align-self-stretch justify-content-center cardSubTitleApp mb-2">
                      As a Dynatrace partner, you have access to a special
                      Dynatrace demo environment, the ultimate resource to
                      deliver impactful demonstrations. The demo environment can
                      also be used as a training tool to familiarize yourself
                      with all the different views and pages of the Dynatrace
                      UI.
                    </div>
                  </div>
                  <ButtonArrow
                    link={"https://demo.live.dynatrace.com/"}
                    buttonName={"Learn More"}
                    width="15%"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="faqTitle">
            <div className="faqHeader">
              <div className="faqTitleText">FAQs</div>
            </div>
          </div>

          <NewsSectionTwo title={TITLE_ONE} subTitle={SUB_TITLE_ONE} />
          <NewsSectionTwo title={TITLE_TWO} subTitle={SUB_TITLE_TWO} />
          <NewsSectionTwo title={TITLE_THREE} subTitle={SUB_TITLE_THREE} />
          <NewsSectionTwo title={TITLE_FOUR} subTitle={SUB_TITLE_FOUR} />
        </div>
      </div>

      <Modal show={showUns} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className="letterType">
            Enablement notifications
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmitUns}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label className="letterType">Email address</Form.Label>
              <Form.Control
                className="letterType"
                name="email"
                type="email"
                placeholder="Enter email"
                value={form.email}
                disabled={
                  form.email !== null &&
                  form.email !== undefined &&
                  form.email?.length > 0
                }
                required={true}
                onChange={onChangeForm}
              />
            </Form.Group>
            <Button onClick={handleSubmitUns} className="letterType">
              Unsubscribe all
            </Button>
            {apiResponse}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleClose}
            className="letterType"
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal className="modalClass" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className="letterType">
            Enablement notifications
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            {/* <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control name="email" type="email" placeholder="Enter email" value={form.email} required={true}  onChange={onChangeForm} />
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicName">
                    <Form.Label>Name</Form.Label>
                    <Form.Control type="text" name="name" onChange={onChangeForm} value={form.name} placeholder="Enter name" required />
                </Form.Group>  */}
            <Form.Group className="mb-3" controlId="formBasicRegion">
              <Form.Label className="letterType">
                Training regions (time zones) you'd like to get notified about:
              </Form.Label>
              <br />
              <Form.Check
                className="letterType"
                inline
                type="checkbox"
                id="NORAM"
                label="Americas (English)"
                name="REGIONS"
                value="NORAM"
                onChange={onChangeCheckForm}
              />
              <br />
              <Form.Check
                className="letterType"
                inline
                type="checkbox"
                id="LATAM"
                label="Americas (Spanish)"
                value={"LATAM"}
                name="REGIONS"
                onChange={onChangeCheckForm}
              />
              <br />
              <Form.Check
                className="letterType"
                inline
                type="checkbox"
                id="EMEA"
                label="Europe | Middle East | Africa"
                name="REGIONS"
                value="EMEA"
                onChange={onChangeCheckForm}
              />
              <br />
              <Form.Check
                className="letterType"
                inline
                type="checkbox"
                id="APAC"
                label="Asia | Australasia"
                value={"APAC"}
                name="REGIONS"
                onChange={onChangeCheckForm}
              />
              <br></br>
              {(hasSubmitted && !form["REGIONS"]) ||
              (hasSubmitted && form["REGIONS"].length === 0) ? (
                <span className="text-danger font-weight-bold">
                  Please insert one or more regions
                </span>
              ) : (
                ""
              )}
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicName">
              <Form.Label className="letterType">
                Training types you'd like to get notified about:
              </Form.Label>
              <Form.Check
                className="letterType"
                inline
                type="checkbox"
                id="ASSOCIATE"
                label="Associate Certification Bootcamp"
                value={"ASSOCIATE"}
                name="TRAINING"
                onChange={onChangeCheckForm}
              />
              <br />
              <Form.Check
                className="letterType"
                inline
                type="checkbox"
                id="PROFESSIONAL"
                label="Professional Certification Bootcamp"
                value={"PROFESSIONAL"}
                name="TRAINING"
                onChange={onChangeCheckForm}
              />
              <br />
              <Form.Check
                className="letterType"
                inline
                type="checkbox"
                id="TECHNICAL_SALES"
                label="Technical Sales Bootcamp"
                value="TECHNICAL_SALES"
                name="TRAINING"
                onChange={onChangeCheckForm}
              />
              <br />
              <Form.Check
                className="letterType"
                inline
                type="checkbox"
                id="WEBINAR"
                label="Tech Update Webinars"
                value={"WEBINAR"}
                name="TRAINING"
                onChange={onChangeCheckForm}
              />
              <br />
              <Form.Check
                className="letterType"
                inline
                type="checkbox"
                id="HOT"
                label="HOT sessions"
                value={"HOT"}
                name="TRAINING"
                onChange={onChangeCheckForm}
              />
              <br />
              <br></br>
              {(hasSubmitted && !form["TRAINING"]) ||
              (hasSubmitted && form["TRAINING"].length === 0) ? (
                <span className="text-danger font-weight-bold">
                  Please insert one or more training events
                </span>
              ) : (
                ""
              )}
            </Form.Group>
            <Button onClick={handleSubmit} className="letterType">
              Subscribe
            </Button>
            {apiResponse}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleClose}
            className="letterType"
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );

  async function handleSubmit(event) {
    const request = new SubscriptionRequestDTO(
      form["name"],
      form["email"],
      form["REGIONS"],
      form["TRAINING"]
    );
    setHasSubmitted(true);
    if (
      !form["REGIONS"] ||
      !form["TRAINING"] ||
      form["REGIONS"].length === 0 ||
      form["TRAINING"].length === 0
    ) {
      console.log("Please fill the region and trainings");
      return;
    }
    setApiResponse(
      <span className="ml-3 text-danger font-weight-bold">{"Waiting..."}</span>
    );
    enablementAction
      .doSubscription(request)
      .then((response) => {
        response.data.isSuccess === true
          ? setApiResponse(
              <span className="ml-3 text-danger font-weight-bold">
                {"Subscription done"}
              </span>
            )
          : setApiResponse(
              <span className="ml-3 text-danger font-weight-bold">
                {"Something went wrong. Try again later."}
              </span>
            );
      })
      .catch((err) => {
        console.error("subscription failed", err);
        setApiResponse(
          <span className="ml-3 text-danger font-weight-bold">
            {"Something went wrong. Try again later."}
          </span>
        );
      });
  }

  async function handleSubmitUns(event) {
    const request = new UnsubscriptionRequestDTO(form["email"]);

    setApiResponse(
      <span className="ml-3 text-danger font-weight-bold">{"Waiting..."}</span>
    );
    enablementAction
      .unsubscribe(request)
      .then((response) => {
        response.data.isSuccess === true
          ? setApiResponse(
              <span className="ml-3 text-danger font-weight-bold">
                {"Unsubscription done"}
              </span>
            )
          : setApiResponse(
              <span className="ml-3 text-danger font-weight-bold">
                {"Something went wrong. Try again later."}
              </span>
            );
      })
      .catch((err) => {
        console.error("subscription failed", err);
        setApiResponse(
          <span className="ml-3 text-danger font-weight-bold">
            {"Something went wrong. Try again later."}
          </span>
        );
      });
  }

  async function getAllEvents() {
    enablementAction
      .getAllEvents()
      .then((response) => {
        let events = Array<{ title; start; end; link; region; type }>();
        const clusters: Array<EventCLusterDTO> = response.data;
        for (const c of clusters) {
          for (const e of c.events) {
            events.push({
              title: e.description,
              start: e.newDate,
              end: e.newDate,
              link: c.redirectUrl,
              region: e.type?.region,
              type: e.type?.name,
            });
          }
        }
        setEventsData(events);
        setEventsDataAll(events);
        return events;
      })
      .catch((err) => {
        console.error("events were not catch. Error: ", err);
      });
  }

  function closeForm() {
    let temp = form;
    temp["REGIONS"] = [];
    temp["TRAINING"] = [];
    setForm(temp);
    setApiResponse(<span></span>);
    setHasSubmitted(false);
    setShow(false);
    setShowUns(false);
  }

  function onChangeForm(e) {
    const name = e.target.name;
    const value = e.target.value;
    setForm({ ...form, [name]: value });
  }

  function onChangeCheckForm(e) {
    const fieldName = e.target.name;
    let temp = form[fieldName] || [];
    const isChecked = e.target.checked;
    const valueField = e.target.value;

    if (isChecked) {
      temp.push(valueField);
    } else {
      let index = temp.indexOf(valueField);
      temp.splice(index, 1);
    }

    setForm({ ...form, [fieldName]: temp });
  }

  function canYouHaveAccess() {
    try {
      if (
        process.env.REACT_APP_PROTECT_PAGE === "true" &&
        window.top?.location.host !== process.env.REACT_APP_ALLOW_API
      ) {
        console.log("You shall not pass");
        history.push("/not-found");
      }
    } catch (err) {}
  }
}

export default Enablement;
